<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="27"
    height="32"
    viewBox="0 0 27 32"
  >
    <defs>
      <path
        id="qtl2a"
        d="M1359.1 723.28l-.03.02c-.1.09-.98.83-1.68 1.4l-5.1-6.74 1.7-1.42c.28-.23.7-.18.92.1a53169.99 53169.99 0 0 1 4.3 5.67c.09.12.14.28.14.44 0 .2-.09.4-.25.53zm-3.09 2.45c-.25.22-1 .59-2.25.59-2.26 0-6.93-1.2-12.85-9.23-7.17-9.73-5.35-15.36-4.05-16.7l.7-.68 5.27 6.87-.76.72c-1.34 1.11-.2 3.02.49 4.16a33.44 33.44 0 0 0 4 5.28c1.46 1.59 2.5 2.63 3.45 2.63.33 0 .64-.13.91-.35l.85-.64 5.1 6.73zm-16.25-27.9a.63.63 0 0 1 .92.1 76470.83 76470.83 0 0 1 4.44 5.8c.1.13.15.29.15.45 0 .2-.09.4-.25.52a.3.3 0 0 0-.04.05l-1.66 1.39-5.26-6.87zm20 24.1a.33.33 0 0 0-.05-.06l-4.29-5.65a1.27 1.27 0 0 0-1.83-.21l-1.95 1.62-1.11.84a.8.8 0 0 1-.52.21c-.7 0-1.72-1.04-2.99-2.41a32.73 32.73 0 0 1-3.91-5.17c-.94-1.56-1.37-2.66-.62-3.28l.99-.94 1.95-1.63a.31.31 0 0 0 .05-.06c.28-.26.44-.62.44-1.01 0-.29-.09-.57-.24-.8a41118.67 41118.67 0 0 0-4.5-5.86 1.27 1.27 0 0 0-1.83-.21l-1.95 1.64-.02.01-.97.93c-.05.06-5 5.42 3.98 17.62 6.1 8.26 11 9.49 13.37 9.49 1.34 0 2.26-.38 2.65-.72l1.13-.83c1.25-1.04 1.75-1.45 1.95-1.65l.01.01c.32-.26.5-.65.5-1.06 0-.29-.09-.57-.25-.81z"
      />
    </defs>
    <g>
      <g transform="translate(-1334 -696)">
        <g>
          <use fill="#363636" xlink:href="#qtl2a" />
          <use
            fill="#fff"
            fill-opacity="0"
            stroke="#363636"
            stroke-miterlimit="50"
            stroke-width=".71"
            xlink:href="#qtl2a"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ThePhoneIcon',
};
</script>
